import "./PayoffDiagramControlsRightComponent.scss";
import {IComponentOptions} from "angular";

export const PayoffDiagramControlsRight = "tfPayoffDiagramControlsRight";

export function payoffDiagramControlsRight(): IComponentOptions {
    return {
        template: "<ng-transclude></ng-transclude>",
        transclude: true,
        require: {
            diagram: "^^tfPayoffDiagram"
        },
        controller: () => {}
    };
}
